module.exports = __webpack_public_path__ + "img/kachshop.f450f52.png";